import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Axios from 'axios'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

var url_params = {};
window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
    url_params[key] = value;
});

Vue.prototype.$API_TOKEN = url_params.API_TOKEN;
Vue.prototype.$shop = url_params.shop;
Vue.prototype.$plan_name = url_params.plan_name;
Vue.prototype.$backendURL = "https://backoffice.pay2m.com";


Vue.prototype.$Axios = Axios

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')
